<div class="fx-xs-column fx-row fx-align-space-between-center pt-15">
    <div class="fx-row">
        <table class="left-table">
            <tbody>
                <tr>
                    <td>
                        <p><strong class="tm-1">{{ "inventory.countedBy" | translate }}</strong></p>
                        <p><span>{{inventory?.usrFirstName}} {{inventory?.usrLastName}}</span></p>
                    </td>
                </tr>
                <tr>
                    <td>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="fx-row">
        <table class="right-table">
            <tbody>
                <tr>
                    <td id="firstRow" class="fx-row">
                        <p><b class="tm-1">{{ "start" | translate }}</b></p>
                        <p><span>{{ inventory?.invStartTS }}</span></p>
                    </td>
                </tr>
                <tr>
                    <td *ngIf="inventory?.endTimeStamp != null; else elseBlock" class="fx-row">
                        <p><strong class="tm-1">{{ "end" | translate }}</strong></p>
                        <p><span>{{ inventory?.endTimeStamp }}</span></p>
                    </td>
                    <ng-template #elseBlock>
                        <td>
                        </td>
                    </ng-template>
                </tr>
            </tbody>
        </table>
    </div>
</div>